export default __webpack_public_path__ + "static/media/mayaLogo.bcbf10f5.svg";